import { React, useState, useEffect } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import { BASE_URL, MAX_UPLOAD_FILE_SIZE } from "../Config";
import ExcelToPDFUploadView from "./ExcelToPDFUploadView";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";

function ExcelToPDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "Excel To PDF Converter Online Free",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);
  //set progress
  //top loading bar
  const [progress, setProgress] = useState(0);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/excel_to_pdf", title: "Convert Excel To PDF Online" },
    data2: { link: "/excel_to_pdf", title: "XLS To PDF Online" },
    data3: { link: "/excel_to_pdf", title: "XlSX To PDF Converter" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
        setProgress,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar progress={progress} />

      {/*Add title and metadata */}
      <title>{title}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Convert Excel to PDF online instantly. Quickly transform spreadsheets into secure, high quality PDFs with our fast and easy Excel to PDF tool."
      ></meta>
      <meta
        name="keywords"
        content="Excel to PDF, convert Excel to PDF, online Excel to PDF, Excel to PDF converter, spreadsheet to PDF, Excel file to PDF, Excel conversion tool, Excel to PDF online, convert XLS to PDF, XLSX to PDF, Excel PDF maker, Excel to PDF fast, secure Excel to PDF, spreadsheet PDF converter, Excel document to PDF, xls to pdf online, xlsx to pdf online, xls to pdf converter, xlsx to pdf converter,"
      ></meta>

      {/* page content */}
      <div>
        {/* Nav Bar */}
        <NavBar />
        {/* Title */}
        <MiscPageTitle title={title} online={true} />
        {/* Upload DOCX View */}
        {/* Upload View maxFileSize = 9.9mb */}
        {/* Runpod datauri size limit = 9.9mb */}
        {showEditFileScreen ? (
          <ExcelToPDFUploadView
            maxFileSize={MAX_UPLOAD_FILE_SIZE}
            allowedFileExtensions={["xls", "xlsx", "csv"]}
          />
        ) : (
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{
              "text/csv": ["csv"],
              "application/vnd.ms-excel": [".xls"],
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                [".xlsx"],
            }}
          />
        )}
        {/* Mid Section */}
        <MiscPageMidSection description="Our Excel to PDF converter online website is a fast, reliable, and easy to use solution for converting Excel spreadsheets into high quality PDF documents. Designed to support XLS and XLSX files, this powerful Excel to PDF online converter accurately transforms tables, formulas, charts, and cell formatting into clean, well structured PDF files. Whether you are a student preparing assignments, an accountant sharing financial reports, or a business professional creating invoices and data summaries, this convert Excel to PDF online tool ensures your spreadsheets remain readable and professionally formatted. With a simple upload and convert process, users can quickly turn Excel files into PDFs without installing any software. Our Excel spreadsheet to PDF converter online works directly in your browser, saving time and improving productivity. The generated PDF files are optimized for easy sharing, printing, and long term storage, making them ideal for emails, official documentation, and record keeping. Strong security measures are in place to protect your files, with automatic deletion after conversion to maintain privacy. If you’re looking for a secure, accurate, and high performance Excel to PDF converter online that delivers consistent results without data loss or formatting issues, this website is the perfect choice for all your spreadsheet conversion needs." />
        {/* How to use */}
        <HomeScreenHowToUse
          steps={{
            step1: "Select",
            step2: "Upload",
            step3: "Convert",
            step4: "Download",
          }}
        />
        {/* Why use section */}
        <MiscWhyUse
          title="Excel To PDF Converter"
          why_use={[
            {
              title: "Preserve Spreadsheet Formatting",
              description:
                "This Excel to PDF converter online keeps tables, charts, formulas, fonts, and cell alignment intact. When you convert Excel to PDF online, your spreadsheets appear consistent and professional on all devices.",
            },

            {
              title: "Universal File Compatibility",
              description:
                "Using a convert Excel to PDF online tool creates PDF files that can be opened on any operating system without requiring Microsoft Excel or other spreadsheet software.",
            },

            {
              title: "Professional and Print Ready Output",
              description:
                "This Excel spreadsheet to PDF converter online generates clean, print ready documents, making it ideal for reports, invoices, financial statements, and official records.",
            },

            {
              title: "Secure and Read Only Sharing",
              description:
                "Converting Excel to PDF helps protect sensitive data from unauthorized editing. This secure Excel to PDF online website ensures safe document sharing.",
            },

            {
              title: "No Software Installation Required",
              description:
                "Our browser based Excel to PDF converter online allows users to convert Excel spreadsheets to PDF instantly without installing any software or plugins.",
            },

            {
              title: "Faster Workflow and Productivity",
              description:
                "This fast convert Excel to PDF online tool saves time by enabling quick spreadsheet conversions, improving productivity for students, professionals, and businesses.",
            },

            {
              title: "Ideal for Business and Academic Use",
              description:
                "Our Excel to PDF online converter is perfect for business reports, budgets, assignments, invoices, and data analysis documents that require a professional PDF format.",
            },

            {
              title: "Optimized File Size for Easy Sharing",
              description:
                "Our Excel to PDF converter online creates optimized PDF files that are easy to email, upload, and store without compromising quality.",
            },

            {
              title: "Reliable Long Term Archiving",
              description:
                "Converting Excel to PDF online helps preserve spreadsheet data in a stable format, making PDFs ideal for long term storage and record keeping.",
            },
          ]}
        />
        {/* Looking for section */}
        <MiscPageLookingFor data={lookingForObject} />
        {/* Footer */}
        <Footer />
      </div>
    </PageContext.Provider>
  );
}

export default ExcelToPDFMain;
